import React, { useEffect, useState } from "react";
import CrudForm from "../../components/dashboard/form/CrudForm";
import DashboardWrapper from "../../components/DashboardWrapper";
import { useSingletonCrud } from "../../hooks/useSingletonCrud";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import Breadcrumb from "../../components/Breadcrumbdashboard";



export default function ReadAndUpdateProfile() {
  const navigate = useNavigate();

  // 🔥 IMPORTANT: pass fileFields
  const { loading, errors, fetchSingleton, updateSingleton } =
    useSingletonCrud("backend/admin-profile", ["profile_image"]);

  const [initialData, setInitialData] = useState(null);

  // DB columns
  const allowedFields = [
    "username",
    "email",
    "phone_number",
    "user_role",
    // "profile_image",
  ];

  const isEqual = (obj1, obj2) => {
    if (!obj1 || !obj2) return false;

    return allowedFields.every((key) => obj1[key] === obj2[key]);
  };

 // ============================================================
// LOAD CURRENT LOGGED-IN USER PROFILE
// ============================================================
useEffect(() => {
  let isMounted = true;

  const fetchData = async () => {
    try {
      // Clear old profile immediately
      setInitialData(null);

      const profile = await fetchSingleton();

      console.log("PROFILE API RESPONSE:", profile);

      if (!isMounted) return;

     const user = profile?.user || profile?.data?.user || {};

      const formatted = {
        username: user?.username ?? "",
        email: user?.email ?? "",
        phone_number: user?.phone_number ?? "",
        profile_image: user?.profile_image ?? null,
        user_role: user?.role?.name ?? "",
      };

      console.log("CURRENT USER PROFILE:", formatted);

      setInitialData(formatted);
    } catch (error) {
      console.error("Error fetching profile:", error);

      if (!isMounted) return;

      Swal.fire({
        title: "Error",
        text: "Failed to load profile data",
        icon: "error",
        confirmButtonText: "OK",
        confirmButtonColor: "#FB6C22",
      });
    }
  };

  fetchData();

  return () => {
    isMounted = false;
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
}, []);
  // 🔹 UPDATE PROFILE
  const handleSubmit = async (formData) => {
    if (!/^\d{10}$/.test(formData.phone_number)) {
      Swal.fire({
        title: "Invalid Phone Number",
        text: "Phone number must contain exactly 10 digits",
        icon: "error",
        confirmButtonText: "OK",
        confirmButtonColor: "#FB6C22",
      });

      return;
    }

    try {
      const dataToSend = {
        username: formData.username,
        email: formData.email,
        phone_number: formData.phone_number,
        profile_image: formData.profile_image,
      };

      console.log("UPDATE DATA:", dataToSend);

      const res = await updateSingleton(dataToSend);

      console.log("UPDATE RESPONSE:", res);

      Swal.fire({
        title: "Success",
        text: "Profile updated successfully",
        icon: "success",
        confirmButtonText: "OK",
        confirmButtonColor: "#FB6C22",
      });

      // ============================================================
      // 🔥 Handle API response
      // If response is:
      //
      // {
      //   status: true,
      //   user: {...}
      // }
      //
      // then use res.user
      // ============================================================

    const updatedUser =
  res?.user ||
  res?.data?.user ||
  res?.data ||
  res ||
  {};

    const updatedData = {
  username: updatedUser?.username ?? formData.username ?? "",
  email: updatedUser?.email ?? formData.email ?? "",
  phone_number:
    updatedUser?.phone_number ?? formData.phone_number ?? "",
  profile_image:
    updatedUser?.profile_image ??
    formData.profile_image ??
    null,

  // ✅ Dynamic role name
  user_role:
    updatedUser?.role?.name ??
    formData.user_role ??
    "",
};

setInitialData(updatedData);
    } catch (error) {
      console.error("Error updating profile:", error);

      let msg = "Failed to update profile";

      if (error.response?.data) {
        if (error.response.data.errors) {
          msg = Object.values(error.response.data.errors)
            .flat()
            .join(", ");
        } else if (error.response.data.message) {
          msg = error.response.data.message;
        }
      }

      Swal.fire({
        title: "Error",
        text: msg,
        icon: "error",
        confirmButtonText: "OK",
        confirmButtonColor: "#FB6C22",
      });
    }
  };

  const shouldShowLoading = loading && !initialData;

  return (
    <DashboardWrapper>
      <div className="container-xxl flex-grow-1 p-3">

        {/* Breadcrumb */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <Breadcrumb />
        </div>

        <div className="row">
          <div className="col-12">

            <div className="card shadow-sm">

              {/* Card Header */}
              <div className="card-header py-3">
                <h1 className="h5 mb-0">
                  Manage My Profile
                </h1>
              </div>

              {/* Card Body */}
              <div className="card-body p-3">

                {shouldShowLoading ? (
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ minHeight: "200px" }}
                  >
                    <div className="spinner-border text-primary" />
                  </div>
                ) : (
                  <>
                    <div className="profile-form-compact">

                      <CrudForm
                        initialData={initialData || {}}
                        onSubmit={handleSubmit}
                        allowedFields={allowedFields}

                        customFields={{
                          username: {
                            label: "Username",
                            type: "text",
                            placeholder: "Enter username",
                          },

                          email: {
                            label: "Email",
                            type: "email",
                            placeholder: "Enter email",
                          },

                          phone_number: {
                            label: "Phone Number",
                            type: "text",
                            placeholder: "Enter phone number",
                            maxLength: 10,
                            pattern: "[0-9]{10}",
                            inputMode: "numeric",
                          },

                          // profile_image: {
                          //   label: "Profile Image",
                          //   type: "file",
                          //   accept: "image/*",
                          // },

                          user_role: {
                            label: "User Role",
                            type: "text",
                            placeholder: "Enter User Role",
                            readOnly: true,
                            disabled: true,
                          },
                        }}
                      />

                    </div>

                    {errors.fetch && (
                      <div className="text-danger mt-2">
                        Error: {errors.fetch}
                      </div>
                    )}

                    {errors.update && (
                      <div className="text-danger mt-2">
                        Error: {errors.update}
                      </div>
                    )}
                  </>
                )}

              </div>
            </div>

          </div>
        </div>
      </div>

      {/* ============================================================
          COMPACT 2-COLUMN UI
          ============================================================ */}

      <style>
        {`
          .profile-form-compact form {
            display: grid !important;
            grid-template-columns: repeat(2, minmax(0, 1fr));
            column-gap: 24px;
            row-gap: 14px;
            align-items: start;
          }

          .profile-form-compact form > div {
            margin-bottom: 0 !important;
          }

          .profile-form-compact .form-group,
          .profile-form-compact .mb-3,
          .profile-form-compact .mb-4 {
            margin-bottom: 0 !important;
          }

          .profile-form-compact label {
            margin-bottom: 5px !important;
            font-size: 14px;
          }

          .profile-form-compact input,
          .profile-form-compact select,
          .profile-form-compact textarea {
            height: 40px;
            font-size: 14px;
          }

          .profile-form-compact form button[type="submit"] {
            grid-column: 1 / -1;
            width: 150px;
            min-width: 130px;
            margin-top: 8px;
          }

          @media (max-width: 767px) {
            .profile-form-compact form {
              grid-template-columns: 1fr;
              column-gap: 0;
            }

            .profile-form-compact form button[type="submit"] {
              grid-column: auto;
              width: 100%;
            }
          }
        `}
      </style>

    </DashboardWrapper>
  );
}